import{useContext as r}from"react";import{AdCollapseContext as o}from"./index.js";const t=()=>{const t=r(o);if(!t)throw new Error("ad collapse context provider not available");return t};export{t as default};
